<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'KlModal',
    props: {
        isOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        fullscreen: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['close'],
    inheritAttrs: false, // ensure fallthrough attributes are bound to the correct root div with v-binf="$attrs"
});
</script>

<template>
    <div :class="{ 'kl-modal': true, 'fullscreen': fullscreen }" v-if="isOpen" v-bind="$attrs">
        <div class="kl-modal__header"><slot name="modal-header"></slot></div>
        <div class="kl-modal__content"><slot name="modal-content"></slot></div>
        <div class="kl-modal__footer"><slot name="modal-footer"></slot></div>
    </div>
    <div class="vl-modal-backdrop kl-modal-backdrop-override" v-if="isOpen" @click="$emit('close')" />
</template>

<style scoped lang="scss">

    .kl-modal-backdrop-override {
        // TODO: can't use this override because of global header
        // ref: Bug 218483: tooltips werken niet in een modal
        //z-index: 1000; // vl-design-system vl-modal-backdrop z-index = 10008; but vl-tooltips are on 9999
    }

    .kl-modal {
        position: fixed;
         z-index: 11000; // vl-design-system vl-modal z-index = 10009; but vl-tooltips are on 9999
        // TODO: can't use this override because of global header
        // ref: Bug 218483: tooltips werken niet in een modal
        //z-index: 1001;
        left: 20px;
        right: 20px;
        top: 20px;
        bottom: 20px;

        background: $vl-white;

        ////////////////////////////////////
        // copy from vl-modal-dialog
        border: 0;
        -webkit-box-shadow: 0 0 2.1rem 0 rgba(0, 0, 0, .3);
        box-shadow: 0 0 2.1rem #0000004d;
        // end copy from vl-modal-dialog
        ////////////////////////////////////

        display: flex;
        flex-direction: column;

        &__header {
        }

        &__content {
            flex-grow: 1;
        }

        &__footer {
        }
    }
    .kl-modal.fullscreen {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

</style>
